"use client";

import { FC } from "react";
import Link from "next/link";
import { Flex, Box, Text } from "@chakra-ui/react";
import { css, Global } from "@emotion/react";
import Logo from "../../../components/PageLayout/Header/Logo";
import Button from "../../../components/Button";

const NotFoundPage: FC = () => (
  <>
    <Global
      styles={css`
        body {
          background-color: #023648;
        }
      `}
    />
    <Flex
      flexDirection="column"
      justifyContent="center"
      m="auto"
      p={10}
      minHeight="100vh"
    >
      <Flex asChild justifyContent="center" mb={[3, null, null, 12]}>
        <Link href="/">
          <Logo />
        </Link>
      </Flex>

      <Box mx="auto" w="fit-content" maxWidth={1600}>
        <Flex
          gap={[0, null, null, 10]}
          alignItems="center"
          flexDirection="column"
        >
          <Box textAlign="center">
            <Text color="white" fontSize={[18, null, null, 22]}>
              Sorry, we couldn't find this page.
            </Text>

            <Button asChild size="lg" visual="primary" mt={6}>
              <Link href="/">Return to home page</Link>
            </Button>
          </Box>
        </Flex>
      </Box>
    </Flex>
  </>
);

export default NotFoundPage;
